import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { CheckCircle2 } from 'lucide-react';

const LoginPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo and Title */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl mb-4 shadow-lg">
            <span className="text-white font-bold text-2xl">99</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">99.tasks</h1>
          <p className="text-gray-600 dark:text-gray-400">Simple task management for busy people</p>
        </div>

        {/* Clerk Sign In Component */}
        <div className="flex justify-center mb-6">
          <SignIn
            appearance={{
              elements: {
                rootBox: 'w-full',
                card: 'shadow-xl border border-gray-100 dark:border-gray-700 rounded-2xl dark:bg-gray-800',
                headerTitle: 'text-xl font-semibold text-gray-900 dark:text-gray-100',
                headerSubtitle: 'text-gray-600 dark:text-gray-400',
                socialButtonsBlockButton: 'border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700',
                formButtonPrimary: 'bg-blue-600 hover:bg-blue-700',
                footerActionLink: 'text-blue-600 hover:text-blue-700',
              },
            }}
            routing="hash"
            signUpUrl="#/sign-up"
          />
        </div>

        {/* Features */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-700">
          <div className="relative mb-4">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200 dark:border-gray-700"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400">Features</span>
            </div>
          </div>

          <div className="space-y-3">
            <Feature text="Create and organize task lists" />
            <Feature text="Set due dates and priorities" />
            <Feature text="Add subtasks and notes" />
            <Feature text="Tag tasks with colors" />
            <Feature text="Works on mobile and desktop" />
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-gray-500 dark:text-gray-400 text-sm mt-6">
          Built with Emergent
        </p>
      </div>
    </div>
  );
};

const Feature = ({ text }) => (
  <div className="flex items-center gap-3 text-gray-600 dark:text-gray-300">
    <CheckCircle2 className="w-5 h-5 text-blue-500 flex-shrink-0" />
    <span className="text-sm">{text}</span>
  </div>
);

export default LoginPage;
